import { render } from "./DistributorInventory.vue?vue&type=template&id=64927d93"
import script from "./DistributorInventory.vue?vue&type=script&lang=js"
export * from "./DistributorInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__